module.exports = __webpack_public_path__ + "static/media/tutor-rating.d1ab0a9b.svg";